/// <reference path="../../../../Scripts/typings/breeze/breeze.d.ts" />
/// <reference path="../../../../Scripts/typings/q/q.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/shopitemtemplate/services/shopitemtemplaterepository',["require", "exports", "models/breeze", "services/settings", "services/httpclient"], function (require, exports, Data, configuration, http) {
    "use strict";
    var ShopItemTemplateRepository = (function (_super) {
        __extends(ShopItemTemplateRepository, _super);
        function ShopItemTemplateRepository() {
            var serviceUrl = configuration.Settings.getOneClickServicesApi("/activation/api/shop-item"); //.getApiFor("breeze/shopitemtemplates");
            _super.call(this, serviceUrl);
        }
        ShopItemTemplateRepository.prototype.getMemberTypes = function () {
            var service = new http.Channel();
            return service.getDataAsync("/api/shopitemtemplates/getmembertypes/", http.ServiceTarget.portalApi);
        };
        ShopItemTemplateRepository.prototype.read = function (memberType, id) {
            var service = new http.Channel();
            return service.getDataAsync("/activation/api/shop-item/" + memberType + "/" + id, http.ServiceTarget.oneClickServiceApi);
        };
        ShopItemTemplateRepository.prototype.update = function (template) {
            var service = new http.Channel();
            return service.putDataAsync('/activation/api/shop-item', http.ServiceTarget.oneClickServiceApi, template)
                .then(function (data) {
                return;
            })
                .fail(function (exception) {
                return exception;
            });
        };
        ShopItemTemplateRepository.prototype.save = function (template) {
            var service = new http.Channel();
            return service.postDataAsync('/activation/api/shop-item', http.ServiceTarget.oneClickServiceApi, template)
                .then(function (data) {
                return;
            })
                .fail(function (exception) {
                return exception;
            });
        };
        ;
        return ShopItemTemplateRepository;
    }(Data.BreezeRepository));
    exports.ShopItemTemplateRepository = ShopItemTemplateRepository;
});

